




















import UpdateChecker from "@alseco/spa-update-checker/UpdateChecker.vue";
import MaintenanceWorks from "@/components/utility/MaintenanceWorks.vue";
import AppNotification from "./AppNotification.vue";
import AppProgress from "./AppProgress.vue";
import AppHeader from "./AppHeader.vue";
import AppFooter from "./AppFooter.vue";
import { Component, Vue } from "vue-property-decorator";
import CustomDialog from "@/components/dialogs/CustomDialog.vue";

@Component({
  name: "App",
  components: {
    AppHeader,
    AppFooter,
    AppNotification,
    AppProgress,
    UpdateChecker,
    MaintenanceWorks,
    CustomDialog,
  },
})
export default class extends Vue {}
